import { endOfToday } from 'date-fns';

import { periodFromDate } from '@ecp/common/src/utils/dateUtils';

import GRID_COL_PRESET from '../delivery/deliveryCommon';
import { Custom_Preset } from '@bo-ibSheet/common';

const NOTIFICATION = {
  URL: 'api/v1/customer-service/notification',
  DIVISION_ITEMS: [
    { value: '0', labelText: 'FO' },
    { value: '1', labelText: 'BO' },
    { value: '2', labelText: 'PO' },
  ],
  DISPLAY_YN: [
    { value: 'Y', labelText: '전시' },
    { value: 'N', labelText: '미전시' },
  ],
  SEARCH_KEYWORD_OPTIONS: [{ label: '제목', key: 'title' }],
  PO_INIT_VALUE: {
    fromDateTime: periodFromDate({ years: 1 }),
    toDateTime: endOfToday(),
    title: '',
  },

  TOOLTIP_TEXT:
    '웰스토리몰 고객뿐 아니라 관리자에 대해 필요한 내용 및 자료를 공지합니다. 사이트를 부분적용 또는 부분제외하고, FO/BO/PO 구분에 따라 공지사항을 게시할 수 있습니다.',
  GRID_DEFINITION: {
    Def: {
      Row: {
        Height: 44,
        CanFormula: 1,
        CalcOrder: 'applyExceptDivisionName',
      },
    },

    LeftCols: [],
    Cols: [
      { ...Custom_Preset.RowIndex },
      {
        Header: '공지구분',
        Name: 'notificationDivisionText',
        Type: 'Text',
        Width: 120,
        MinWidth: 120,
        CanEdit: 0,
        CanSort: 0,
        CanFocus: 0,
        Align: 'Center',
      },
      {
        ...Custom_Preset.UseYn,
        Header: '전시상태',
        Name: 'displayYn',
        Enum: '|전시|미전시',
        Width: 150,
        MinWidth: 150,
        Key: 'DISP_YN',
      },
      {
        Header: '공지번호',
        Type: 'Text',
        Name: 'notificationSeq',
        Width: 150,
        MinWidth: 150,
        CanEdit: 0,
        Key: 'NOTI_NO',
        CanFocus: 0,
        Align: 'Center',
      },
      {
        Header: '제목',
        Type: 'Text',
        Name: 'title',
        MinWidth: 340,
        CanEdit: 0,
        RelWidth: 1,
        Key: 'NOTI_TITLE',
        CanFocus: 0,
        TextStyle: 4,
        Cursor: 'pointer',
      },
      {
        Header: '사이트',
        Type: 'Text',
        Name: 'applyExceptDivisionName',
        Key: 'APPLY_EXP_DIVI_NM',
        MinWidth: 100,
        Width: 100,
        CanEdit: 0,
        CanFocus: 0,
        Align: 'Center',
        Formula: ({ Row }) => (Row['notificationDivisionText'].includes('FO') ? Row['applyExceptDivisionName'] : ''),
      },
      {
        ...GRID_COL_PRESET.YMDHM,
        Header: '공지시작일시',
        Type: 'Date',
        Name: 'fromDateTime',
        Key: 'START_DTIME',
      },
      {
        ...GRID_COL_PRESET.YMDHM,
        Header: '공지종료일시',
        Type: 'Date',
        Name: 'toDateTime',
        Key: 'END_DTIME',
      },
    ],
  },
};

export default NOTIFICATION;
